import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { failureMessage } from './sourceStatus';

/**
 * Explains why one source failed and offers a retry. Removal stays on the row's
 * existing close button, so a failed source can be kept, retried or dropped
 * without ever being silently excluded from the profile.
 */
const SourceFailureNotice = ({ source, onRetry, isRetrying = false }) => (
  <Box
    mt={0.75}
    px={1.25}
    py={1}
    borderRadius={1}
    sx={{ bgcolor: 'rgba(211, 47, 47, 0.06)' }}
  >
    <Typography variant='caption' color='error.dark' sx={{ display: 'block', lineHeight: 1.45 }}>
      {failureMessage(source)}
    </Typography>
    {onRetry && (
      <Link
        component='button'
        type='button'
        variant='caption'
        underline='always'
        disabled={isRetrying}
        onClick={() => onRetry(source)}
        sx={{
          mt: 0.5,
          color: 'error.dark',
          cursor: isRetrying ? 'default' : 'pointer',
          opacity: isRetrying ? 0.6 : 1,
        }}
      >
        {isRetrying ? 'Retrying…' : 'Try again'}
      </Link>
    )}
  </Box>
);

export default SourceFailureNotice;
